import { zSchema } from "../schema-validation";

export const sortSchema = zSchema.object({
  sortDirection: zSchema.enum(["asc", "desc"]).nullish(),
  sortBy: zSchema.string().nullish(),
});

export type TSortSchema = zSchema.input<typeof sortSchema>;

export const publicSortSchema = zSchema.object({
  sort_direction: sortSchema.shape.sortDirection,
  sort_by: sortSchema.shape.sortBy,
});

export type TPublicSortSchema = zSchema.input<typeof publicSortSchema>;
